


import useFetch from "../../hooks/use-fetch";
import { Station, StationEntry, UserActivity } from '../../models/daily-activity.models'
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useState } from "react";
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import { User } from "../../models/user";
import Config from "../../config";
import DateRangePicker from "../../date-pickers/date-range-picker";
import { DateTime, Duration } from "luxon";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import './leaderboard.css'
import { DateUtils } from "../../utils/date-utils";
import { DurationUtils } from "../../utils/duration-utils";
import DatePicker from "../../date-pickers/date-picker";


interface ILeaderBoardDTO {
   startDate: string;
   stats: ILeaderBoardStationDTO[]
}

interface ILeaderBoardStationDTO {
      stationName: string,
      stationId: string,
      bestTimes: {
            minAvgUserFrameTimeAtStation: Duration,
            minAvgFrameTimeUnique: Duration,
            maxAccumuldatedStationTime: Duration,
            maxUserFrameCount: number,
            maxUserUniqueFrameCount: number,
            avgTimePerFrameLastSevenWorkDays: Duration,

      },
      userData: IAvgFrameLeaderBoardUserDTO[]
}

interface IAvgFrameLeaderBoardUserDTO {
      userId: string;
      profileImage: string;
      firstname: string;
      lastname: string;
      avgUserFrameTimeAtStation: Duration;
      avgUniqueFrameTimeAtStation: Duration;
      accumulatedStationTime: Duration;
      userFrameCount: number;
      userUniqueFrameCount: number;
      eventHistoryId: string;
      stationId: string;
      stationName: string;
      lastEventDate: string;
      isActive: boolean;
}

const LeaderBoardReport = () => {

      const [startDate, setStartDate] = useState<DateTime | null>(null); // let whatever is using it decide the default start/end dates
      const [endDate, setEndDate] = useState<DateTime | null>(null);

      const [userData, setUserData] = useState<ILeaderBoardStationDTO[]>()

      const [userAvgTimeData, setUserAvgTimeData] = useState<ILeaderBoardStationDTO[]>()

      const [range, setRange] = useState<"day" | "weekly" | "month" | "quarter">("day")

      const url = range && startDate && endDate && `${Config.baseUrl}/api/leaderboard?startdate=${startDate.toFormat('yyyy-MM-dd')
            + 'T00:00:01'}&enddate=${endDate.toFormat('yyyy-MM-dd') + 'T23:59:59'}`;
      const { data, loading, error } = useFetch<ILeaderBoardDTO>(url ?? "", null, {});

      const rangeOptions: string[] = ['day', "week", 'month', "quarter"];


      useEffect(() => {

            function getData() {

                  if (!data || ( data && !data.stats) || ( data && data.stats.length === 0)) {
                        return
                  }

                  data.stats.map( station => station.userData.sort((a: IAvgFrameLeaderBoardUserDTO, b: IAvgFrameLeaderBoardUserDTO) => { 
                        if (a.userFrameCount === 0 ) return 1;
                        if (b.userFrameCount === 0 ) return -1;
                        return b.userFrameCount - a.userFrameCount 
                  
                  }));
                  setUserData( data.stats );

                  //copying otherwise the setUserData is completed while the next sort takes place. 
                  let copy = JSON.parse(JSON.stringify(data));
                  copy.stats.map( (s :ILeaderBoardStationDTO) => s.userData.sort((a: IAvgFrameLeaderBoardUserDTO, b: IAvgFrameLeaderBoardUserDTO) => { 
                        const aSec = DurationUtils.toSeconds(a.avgUserFrameTimeAtStation);
                        const bSec = DurationUtils.toSeconds(b.avgUserFrameTimeAtStation);
                        if (aSec === 0) return 1;        //Return 1 so that b goes first
                        if (bSec === 0) return -1;       //Return -1 so that a goes first
                        return aSec - bSec; 
                  }));
                  setUserAvgTimeData(copy.stats);
            }

            getData()

      }, [data]);

      /*** THIS IS USED WhEN THERE IS KNOWN 'goal' OF X units at the station */
      // this is for the width of the progress bar...it maxes at 100%
      function getFramesCompletedAsWidth( stationId: string, total: number) {
            let stationGoal = data.stats.find( s=>s.stationId === stationId)!.bestTimes.maxUserFrameCount;
            if (total > stationGoal) {
                  return "100%"
            } else {
                  return `${Math.floor(((total / stationGoal) * 100))}%`;
            }
      }

      /* used with a goal of X units at the station*/
      // this is for the width of the progress bar...it maxes at 100%
      function getFramesCompletedAsPercentageOfGoal( stationId: string, total: number) {
            let stationGoal = data.stats.find( s => s.stationId === stationId)!.bestTimes.maxUserFrameCount;;
            //   total = 130;
            const diff = total - stationGoal;
            let overPercentage = 0
            if (diff > 0) {
                  // then over 100% of goal... display as 120% etc.
                  overPercentage = Math.floor(stationGoal / total);
            }

            return (Math.floor((total / stationGoal) * 100) + overPercentage);
      }


      /*  THiS WORKS WITH A GOAL OF X UNITS at the station */
      function getStationAverageUnitsAsLeft(stationId: string ) {
            //average units will never be bigger than the leaders total
            // so that would be 100%
            // leaders total may be > 100% of the station Goal
            let stationGoal = data.stats.find( s=> s.stationId === stationId )!.bestTimes.maxUserFrameCount;;;
            // const max = Math.max(...data.map( e=>e.userFrameCount ) );
            // average is percentage of max
            let avgUnits = getStationAverageUnitsPerPerson(stationId);

            let percentageOfMax = Math.floor((avgUnits / stationGoal) * 100);
            return percentageOfMax;
      }

      function getPercentageOffAvgTarget(stationId: string, userAverage: Duration) {
            let minAvgSeconds = Math.min(...userAvgTimeData!.find(( s => s.stationId === stationId))!.userData.map(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation)));

            let userSeconds = DurationUtils.toSeconds(userAverage);


            //   total = 130;
            const diff = userSeconds - minAvgSeconds;

            let prefix = "+";
            if (diff === 0) {
                  prefix = "";
            }
            return `${prefix} ${DateUtils.toHHMMSS_string(diff)}` //( Math.floor( ( total / stationGoal) * 100 ) + overPercentage);
      }
      // this is for the width of the progress bar...it maxes at 100% using the most units as the 100%
      /*
      function getFramesCompletedAsWidth( total: number) {
            // the 'leader is 100%
            let maxsUnits =  Math.max(...userData!.userData.map( e=> e.userFrameCount ) );

            if ( total ===  maxsUnits ) {
                  return "100%"
            } else {
                  return `${ Math.floor( (( total / maxsUnits ) * 100 ) )}%`; 
            }
      }
      */


      // this is for the width of the progress bar...it maxes at 100%
      function getAverageTimeAsWidth(stationId: string, avgTime: Duration) {
            //let stationGoal = 100;

            let station = userAvgTimeData!.find(s => s.stationId === stationId)!;
            let stationEntries = station.userData.filter( e=> DurationUtils.toSeconds(e.avgUserFrameTimeAtStation) > 0 ).map(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation));
            let max = Math.max(...stationEntries);
            let avgSeconds = DurationUtils.toSeconds(avgTime);
            let total = (avgSeconds/ max) * 100;
            if ( total > 100 ) {
                  total = 110; // something wrong in the data but limit the length to 110% so it 'notes' but does not go wildly off the screen.
            }
            return `${Math.floor(total)}%`;

      }

      // this is for the width of the progress bar...it maxes at 100% using the most units as the 100%
      /*
      function getFramesCompletedAsPercentageOfGoal( total: number) {
            let maxsUnits =  Math.max(...userData!.userData.map( e=> e.userFrameCount ) );

            return ( Math.floor( ( total / maxsUnits) * 100 ) );
      }
            */

      function suffixMe(num: number) {

            const j = num % 10;
            const k = num % 100;

            if (j === 1 && k !== 11) {
                  return `${num}st`;
            } else if (j === 2 && k !== 12) {
                  return `${num}nd`;
            } else if (j === 3 && k !== 13) {
                  return `${num}rd`;
            } else {
                  return `${num}th`;
            }
      }

      /*

      function getStationAverageUnitsAsLeft() {
            //average units will never be bigger than the leaders total
            // so that would be 100%
            // leaders total may be > 100% of the station Goal
            let max = Math.max(...data.userData.map( e=> e.userFrameCount ));
           // const max = Math.max(...data.map( e=>e.userFrameCount ) );
            // average is percentage of max
            let avgUnits = getStationAverageUnitsPerPerson();

            // 16 should be about half of 34
            let percentageOfMax =  Math.floor( (  (avgUnits) / max) * 100 );
            return percentageOfMax;
      }
            */

      function getStationAverageUnitsPerPerson(stationId: string) {
            //average units will never be bigger than the leaders total
            // so that would be 100%
            // leaders total may be > 100% of the station Goal
            if (!data) {
                  return 0;
            }

            let station = data.stats.find(s => s.stationId === stationId)

            if (!station) {
                  return 0;
            }

            let totalUnits = station.userData.filter(e => e.userFrameCount!== 0 ).map(e => e.userFrameCount).reduce(function (result, item) {
                  return result + item;
            }, 0);


            let totalPeopleNonZeroUnits = station.userData.filter(e => e.userFrameCount!== 0 )

            let avg = Math.floor(totalUnits / totalPeopleNonZeroUnits.length);
            return avg;
      }

      //** average time  */
      function getStationAverageTimeAsLeft(stationId: string) {

            let maxTime = Math.max(...data.stats.find(s => s.stationId === stationId)!.userData.filter( e=> DurationUtils.toSeconds(e.avgUserFrameTimeAtStation) !== 0).map(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation)));

            let avgTimeSeconds = getStationAverageTimePerPerson(stationId);

            let percentageOfMax = Math.floor((avgTimeSeconds / maxTime) * 100);
            return percentageOfMax;
      }

      function getStationAverageTimePerPerson(stationId: string) {
            //average units will never be bigger than the leaders total
            // so that would be 100%
            // leaders total may be > 100% of the station Goal

            let station = data.stats.find(s => s.stationId === stationId)!
            let totalSeconds = station.userData.filter(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation) !== 0 ).map(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation)).reduce(function (result, item) {
                  return result + item;
            }, 0);

            let totalUnits = station.userData.map(e => e.userFrameCount).reduce(function (result, item) {
                  return result + item;
            }, 0);

            let noneZeroDurationUser = station.userData.filter(e => DurationUtils.toSeconds(e.avgUserFrameTimeAtStation) !== 0 )

            let avg = Math.floor(totalSeconds / noneZeroDurationUser.length);  //todo is a user has 0 time should be included?
            return avg;
      }


      return (
            <div className='report leaderboard' >
                  <>

                        <div className="calendar-selector">
                              <div className='flex flex-row pl-5'>
                              <DatePicker startDateCallback={(dateString) => {

                                          setStartDate(DateTime.fromISO(dateString).toLocal());
                                          setEndDate( DateTime.fromISO(dateString).endOf('day').toLocal())
                                    }} />


{/*
                                    <DateRangePicker startDateCallback={(dateString) => {
                                          setStartDate(DateTime.fromISO(dateString));
                                    }}

                                          endDateCallback={(dateString) => {
                                                setEndDate(DateTime.fromISO(dateString));
                                          }} />

                                    <div className="card flex justify-content-center m-4">
                                          <div className="flex flex-wrap gap-4">
                                                <div style={{ fontSize: "15px", color: "white", fontWeight: "700" }}> Group By:</div>
                                                {rangeOptions && rangeOptions.map(option => {
                                                      return (
                                                            <div className="range-radio-options flex align-items-center">
                                                                  <RadioButton style={{ color: "white" }} inputId={option} name="range" value={option} onChange={(e: RadioButtonChangeEvent) => setRange(e.value)} checked={range === option} />
                                                                  <label htmlFor={option} className="ml-2">{option}</label>
                                                            </div>
                                                      )

                                                })}
                                          </div>
                                    </div>

*/}

                              </div>
                        </div>
                  
                              <h1>Leader Board</h1>
                              { process.env.REACT_APP_ENV==='development'  && 
                                  <div> {startDate?.toISO()} {endDate?.toISO()}</div>
                               }
                             <h3> {startDate?.toLocaleString()}</h3>
                             
            
                        {error && <div>An error occurred loading the report.</div>}

                        {loading && <div> <ProgressSpinner /> Loading...</div>}

       
                        {((loading === false && !data ) || (data && data.stats.length === 0 )) &&

                              <div className="text-lg"> There are no entries for the selected day(s) </div>
                         }

                        {data &&  data.stats.length > 0 && data.stats.map( (station: ILeaderBoardStationDTO ) => {

                              return (
                      
                              <Card title={<><div className="p-card-title">{station.stationName}</div> <div style={{fontSize:".5rm"}}></div></>}>

                                    <div className="grid">

                                          <div className="leaderboard-wrapper col">
                                                <h2>Average Units</h2>
                                                <h3>target is the previous daily record (last 7 days)</h3>
                                                
                                                <div className="station" >

                                                {userData && userData.length > 0 && userData.find( s=>s.stationId === station.stationId)?.userData && userData.find( s=>s.stationId === station.stationId)!.userData.length > 0 && userData.find( s=>s.stationId === station.stationId)?.userData.map((user: IAvgFrameLeaderBoardUserDTO, index: number) => {
                                                      return (
                                                          
                                                            <div className={`leaderboard-entry ${index === 0 ? 'leader' : ""}`}>
                                                                  <div className='profile'>
                                                                        <div className="leader-position">{suffixMe(index + 1)}</div>
                                                                        <div className="profile-pic">
                                                                              <img alt="" src={user.profileImage ? user.profileImage : `data:image/png;base64,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`} />
                                                                        </div>
                                                                  </div>
                                                                  <div className="center-column">

                                                                        <div className='username'>
                                                                              {user.firstname}{user.lastname}
                                                                        </div>
                                                                        <div className="totalframes">
                                                                              <div className="progress-line-outline">
                                                                                    <div className="progress-line" style={{ width: getFramesCompletedAsWidth(station.stationId, user.userFrameCount) }} >

                                                                                    </div>
                                                                                    <div className="station-average-line" style={{ left: `${getStationAverageUnitsAsLeft(station.stationId)}%` }}>

                                                                                    </div>
                                                                              </div>
                                                                        </div>
                                                                        <div className={`percent-of-target ${getFramesCompletedAsPercentageOfGoal(station.stationId, user.userFrameCount) > 100 ? "overtarget" : ""}`}>
                                                                              {getFramesCompletedAsPercentageOfGoal(station.stationId, user.userFrameCount)}% of target
                                                                        </div>
                                                                  </div>

                                                                  <div className="total">
                                                                        {user.userFrameCount}
                                                                  </div>

                                                      </div>
                                               
                                                      )
                                                })}
                                                <div className="avg-units-per-person">
                                                      <div>Average Units:  {getStationAverageUnitsPerPerson(station.stationId)}</div>
                                                      <div style={{ color: "darkorange" }}>Previous Daily Record: {station && station.bestTimes && station.bestTimes.maxUserFrameCount}</div>
                                                </div>
                                                </div>
                                          </div>  

                                          <div className="leaderboard-wrapper col">
                                                <h2>Average Time Per Unit</h2>
                                                <h3>shorter is faster</h3>

                                                <div className="station" >
                                                {userAvgTimeData && userAvgTimeData.length > 0 && userAvgTimeData.find( s=>s.stationId === station.stationId)?.userData && userAvgTimeData.find( s=>s.stationId === station.stationId)!.userData.length > 0
                                     && userAvgTimeData.find( s=>s.stationId === station.stationId)?.userData.map((user: IAvgFrameLeaderBoardUserDTO, index: number) => {
                                                   
                                                            return (
                                                                  <div className={`leaderboard-entry ${index === 0 ? 'leader' : ""}`}>
                                                                        <div className='profile'>
                                                                              <div className="leader-position">{suffixMe(index + 1)}</div>
                                                                              <div className="profile-pic">
                                                                                    <img alt="" src={user.profileImage ? user.profileImage : `data:image/png;base64,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`} />
                                                                              </div>
                                                                        </div>
                                                                        <div className="center-column">

                                                                              <div className='username'>
                                                                                    {user.firstname}{user.lastname}
                                                                              </div>
                                                                              <div className="totalframes">
                                                                                    <div className="progress-line-outline">
                                                                                          <div className={ `progress-line ${  DurationUtils.toSeconds(user.avgUniqueFrameTimeAtStation ) === 0 ? 'zero-time' : ''}` } style={{ width: getAverageTimeAsWidth(station.stationId, user.avgUniqueFrameTimeAtStation) }} >

                                                                                          </div>
                                                                                          <div className="station-average-line" style={{ left: `${getStationAverageTimeAsLeft(station.stationId)}%` }}>

                                                                                          </div>
                                                                                    </div>
                                                                              </div>
                                                                              <div className={`off-average-target ${index === 0 ? 'leader' : ""}`}>
                                                                                    {getPercentageOffAvgTarget( station.stationId, user.avgUserFrameTimeAtStation)} per frame
                                                                              </div>
                                                                        </div>

                                                                        <div className="total">
                                                                              {DurationUtils.formatDuration(user.avgUserFrameTimeAtStation)}
                                                                        </div>


                                                                  </div>

                                                            )
                                                      })}
                                                </div>
                                 
                      

                                                <div className="avg-units-per-person">
                                                      <div>Average Time:  { data && data.stats.find( (s: ILeaderBoardStationDTO) => s.stationId === station.stationId)!.userData &&  DateUtils.toHHMMSS_string(getStationAverageTimePerPerson(station.stationId)) }</div>
                                                      <div style={{color: "darkorange"}}>Average Last 7 days: {  data && data.stats.find( s => s.stationId === station.stationId)!.bestTimes &&  DurationUtils.formatDuration( data.stats.find( s => s.stationId === station.stationId)!.bestTimes.avgTimePerFrameLastSevenWorkDays)}</div>
                                                </div>


                                          </div> 
                                    </div>
                                                
                              </Card>
                       )})}


               </>
            </div>
      )
}

export default LeaderBoardReport;
/*
         <div className='report' style={{maxWidth: "800px"}}>
                  <>
                        <Card>

                              <div className="report-title-wrapper">
                                    <div className="report-title">FBA Picklist</div> 
                              </div>
                              <p> Upload FBA pdf(s) to add them to the google sheet and generate a picklist</p>
                              <UppyDropZone/>
                        </Card>

                        <Card>
                        
                        </Card>
                  </>
            </div>
            */